import React from 'react';
import './ChristmasEffect.scss';

/**
 * 聖誕節雪花特效
 */
const ChristmasEffect = () => {
  return (
    <div className="christmas-effect">
      <div className="snowflakes" aria-hidden="true">
        {[...Array(50)].map((_, i) => (
          <div key={i} className="snowflake"></div>
        ))}
      </div>
    </div>
  );
};

export default ChristmasEffect;

